import React from "react";
import { toast } from "react-toastify";
import { ModeEditOutlineTwoTone } from "@mui/icons-material";
import { Box, CircularProgress, IconButton, Typography } from "@mui/material";

import AppTable from "components/Shared/AppTable";
import FormDrawer from "components/Shared/FormDrawer";

import { useShipmentFulfillmentDetailContext } from "contexts/ShipmentFulfillmentContext";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useTablePagination } from "hooks";

import {
  useLazyListCollectionStopsQuery,
  useUpdateCollectionStopsMutation
} from "store/services/collectionApi";

import CollectionStopsForm from "./CollectionStopsForm";
import AppTableDateTime from "components/Shared/AppTableDateTime";
// import { useShipmentFulfillmentDetailContext } from "contexts/ShipmentFulfillmentContext";

const CollectionStopList = () => {
    const [showStopForm, setShowStopForm] = React.useState(false);
    const [selectedStop, setSelectedStop] = React.useState(null);
    const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
        useTablePagination();

        const { fulfillmentDetail } = useShipmentFulfillmentDetailContext();    
        // const { ShipmentDetail } = useShipmentDetailContext();
        const collectionId = fulfillmentDetail?._id;
    const columns = [
        {
            name: "Location",
            selector: (row) => row?.stopLocation?.location,
            cell: (row) => row?.stopLocation?.location || "-",
        },
        {
            name: "Latitude",
            selector: (row) => row?.stopLocation?.lat,
            cell: (row) => row?.stopLocation?.lat || "-",
        },
        {
            name: "Longitude",
            selector: (row) => row?.stopLocation?.lon,
            cell: (row) => row?.stopLocation?.lon || "-",
        },
        {
            name: "Stop Time",
            selector: (row) => row?.stopTime,
            cell: (row) => <AppTableDateTime date={row?.stopTime} />
        },
       
        {
            name: "Actions",
            cell: (row) => (
                <IconButton
                    size="small"
                    aria-label="Edit Stop"
                    // disabled={ShipmentDetail?
                    // .status === "Delivered"}
                    onClick={() => {
                        setSelectedStop(row);
                        setShowStopForm(true);
                    }}
                >
                    <ModeEditOutlineTwoTone />
                </IconButton>
            ),
            ignoreRowClick: true,
            right: true,
        },
    ];

    // RTK Query hooks
    const [updateStop, { isLoading: updatingStop }] = useUpdateCollectionStopsMutation();
    const [fetchStops, { data: stopsRes, isLoading, isFetching }] = useLazyListCollectionStopsQuery();
    // Cancel edit form
    const handleCancelStop = () => {
        setShowStopForm(false);
        setSelectedStop(null);
    };

    // Update stop handler
    const handleUpdateStop = async (data) => {
        if (!data?.stopLocation?.location) {
            toast.error("Stop location is required!");
            return;
        }
    
        try {
            const payload = {
                collectionId,
                stopId: selectedStop?._id,
                stopLocation: {
                    location: data.stopLocation.location,
                    lat: data.stopLocation.lat ?? null,
                    lon: data.stopLocation.lon ?? null,
                },
                stopTime: data.stopTime,
            };
    
            await updateStop(payload).unwrap();
            toast.success("Stop updated successfully!");
            handleCancelStop();
            fetchStops({ collectionId });
        } catch (err) {
            toast.error(err?.data?.message ?? "Failed to update stop!");
        }
    };
    React.useEffect(() => {
        if (collectionId) {
          fetchStops({ collectionId });
        }
      }, [collectionId, fetchStops]);
      

    return (
        <div>
            <BreadcrumbLayout.Paper>
                {stopsRes?.stops?.length ? (
                    <AppTable
                        columns={columns}
                        data={stopsRes?.stops ?? []}
                        progressPending={isLoading || isFetching}
                        paginationServer
                        paginationPerPage={perPage}
                        paginationTotalRows={stopsRes?.totalItems ?? 0}
                        paginationDefaultPage={currentPage}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                    />
                ) : (
                    <Box display="flex" alignItems="center" justifyContent="center" padding={2}>
                        {isLoading || isFetching ? (
                            <>
                                <CircularProgress size={24} />
                                <Typography variant="body2" marginLeft={1}>Loading Shipment Stops...</Typography>
                            </>
                        ) : (
                            <Typography variant="body2">No stops found.</Typography>
                        )}
                    </Box>
                )}
            </BreadcrumbLayout.Paper>

            <FormDrawer
                title={selectedStop ? "Edit Stop" : "Add Stop"}
                open={showStopForm}
                onClose={handleCancelStop}
            >
                <CollectionStopsForm
                    isBusy={updatingStop}
                    shipmentStop={selectedStop}
                    onSubmit={handleUpdateStop}
                    onCancel={handleCancelStop}
                />
            </FormDrawer>
        </div>
    );
};

export default CollectionStopList;
